import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-8">
      <div className="container mx-auto flex flex-col items-center space-y-6">
        <h1 className="text-3xl font-bold">Easy English</h1>
        <p className="text-center max-w-md">
          Nâng cao kỹ năng tiếng Anh mỗi ngày với Easy English.
          Đồng hành cùng bạn trên hành trình chinh phục ngôn ngữ.
        </p>
        <div className="flex space-x-6">
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500" aria-label="Facebook">
            <Facebook size={24} />
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500" aria-label="Instagram">
            <Instagram size={24} />
          </a>
          <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400" aria-label="Twitter">
            <Twitter size={24} />
          </a>
          <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-red-500" aria-label="Youtube">
            <Youtube size={24} />
          </a>
        </div>
        <div className="text-sm text-gray-400">
          &copy; {new Date().getFullYear()} Easy English. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
